import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "להכיר את הפחד",
    opening: localizedGenderNode(
      [
      "היום אני לא דוחף/ת את עצמי. אני רק מזהה: יש בי פחד ממפגש.",
      "אני איתי.",
      "נשימה אחת."
    ],
      [
      "היום אני לא דוחף/ת את עצמי. אני רק מזהה: יש בי פחד ממפגש.",
      "אני איתי.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני חושב/ת על מפגש עם אנשים?",
      "איזה חלק בי רוצה להיעלם או לברוח?",
      "מה אני בוחר/ת/ה לשמוע מעצמי עכשיו?"
    ],
      [
      "מה קורה בי כשאני חושב/ת על מפגש עם אנשים?",
      "איזה חלק בי רוצה להיעלם או לברוח?",
      "מה אני בוחר/ת/ה לשמוע מעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני קורא/ת לזה בשם, זה פחות מפחיד."
    ],
      [
      "כשאני קורא/ת לזה בשם, זה פחות מפחיד."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת לעצמי בשקט \"אני איתי\".",
      "אני אומר/ת לעצמי בשקט \"אני איתי\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע הראשון שבו הפחד עולה.",
      "אני לא מתקדם/ת. רק מבחין/ה.",
      "נשימה אחת."
    ],
      [
      "היום אני שם/ה לב לרגע הראשון שבו הפחד עולה.",
      "אני לא מתקדם/ת. רק מבחין/ה.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי במהלך היום הפחד מופיע?",
      "מה הדבר הראשון שאני מרגיש/ה בגוף?",
      "מה המחשבה הראשונה שקופצת?"
    ],
      [
      "מתי במהלך היום הפחד מופיע?",
      "מה הדבר הראשון שאני מרגיש/ה בגוף?",
      "מה המחשבה הראשונה שקופצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הרגע הראשון הוא סדק קטן של בחירה."
    ],
      [
      "הרגע הראשון הוא סדק קטן של בחירה."
    ]
    ),
    action: localizedGenderNode(
      "כשזה עולה אני עוצר/ת לשתי נשימות.",
      "כשזה עולה אני עוצר/ת לשתי נשימות."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הגוף שלי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לגוף שלי מילה אחת.",
      "בלי שיפוט. רק תיאור.",
      "נשימה אחת."
    ],
      [
      "היום אני נותן/ת לגוף שלי מילה אחת.",
      "בלי שיפוט. רק תיאור.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה זה יושב בגוף? (בטן / חזה / גרון)",
      "מה הגוף מנסה לעשות בשבילי?",
      "איזה ריכוך קטן אפשר לתת לו?"
    ],
      [
      "איפה זה יושב בגוף? (בטן / חזה / גרון)",
      "מה הגוף מנסה לעשות בשבילי?",
      "איזה ריכוך קטן אפשר לתת לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף שלי לא נגדי. הוא מנסה לשמור."
    ],
      [
      "הגוף שלי לא נגדי. הוא מנסה לשמור."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה לעשר שניות.",
      "יד על החזה לעשר שניות."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הסיפור בראש",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל/ה בין מה שקורה למה שאני מספר/ת.",
      "אני רואה את הסיפור.",
      "נשימה אחת."
    ],
      [
      "היום אני מבדיל/ה בין מה שקורה למה שאני מספר/ת.",
      "אני רואה את הסיפור.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה סיפור אני מספר/ת על מפגש?",
      "איזה פירוש אני נותן/ת למבטים או לשתיקה?",
      "איזו אפשרות רכה אחרת קיימת?"
    ],
      [
      "איזה סיפור אני מספר/ת על מפגש?",
      "איזה פירוש אני נותן/ת למבטים או לשתיקה?",
      "איזו אפשרות רכה אחרת קיימת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא עובדה."
    ],
      [
      "סיפור הוא לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת לעצמי \"זה סיפור, לא ודאות\".",
      "אני אומר/ת לעצמי \"זה סיפור, לא ודאות\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "טריגרים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מדליק את הפחד.",
      "זה ידע, לא אשמה.",
      "נשימה אחת."
    ],
      [
      "היום אני מזהה מה מדליק את הפחד.",
      "זה ידע, לא אשמה.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה סוג מקום, אדם או רעש מפעיל אותי?",
      "מה עושה את זה חזק יותר?",
      "מה מרכך את זה אפילו קצת?"
    ],
      [
      "איזה סוג מקום, אדם או רעש מפעיל אותי?",
      "מה עושה את זה חזק יותר?",
      "מה מרכך את זה אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מכיר/ה טריגר, אני פחות מופתע/ת."
    ],
      [
      "כשאני מכיר/ה טריגר, אני פחות מופתע/ת."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת טריגר אחד ומתבונן/ת בו בלי לברוח.",
      "אני בוחר/ת טריגר אחד ומתבונן/ת בו בלי לברוח."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הדפוס שלי",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל/ת על הדפוס שלי סביב אנשים.",
      "בלי ביקורת.",
      "נשימה אחת."
    ],
      [
      "היום אני מסתכל/ת על הדפוס שלי סביב אנשים.",
      "בלי ביקורת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני עושה כדי להגן על עצמי במפגש?",
      "מה המחיר של ההגנה הזו?",
      "מה יכול להיות קצת אחרת?"
    ],
      [
      "מה אני עושה כדי להגן על עצמי במפגש?",
      "מה המחיר של ההגנה הזו?",
      "מה יכול להיות קצת אחרת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן מספיק כדי לשחרר לופ."
    ],
      [
      "שינוי קטן מספיק כדי לשחרר לופ."
    ]
    ),
    action: localizedGenderNode(
      "אני מאפשר/ת לעצמי שינוי קטן פעם אחת.",
      "אני מאפשר/ת לעצמי שינוי קטן פעם אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "פחד מדחייה",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שמסתתר מתחת.",
      "אני נשאר/ת איתו רגע.",
      "נשימה אחת."
    ],
      [
      "היום אני נוגע/ת בפחד שמסתתר מתחת.",
      "אני נשאר/ת איתו רגע.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני הכי חושש/ת שיקרה במפגש?",
      "איזה משפט פנימי עולה כשאני מדמיין/ת דחייה?",
      "מה יכול לעזור לי להרגיש קצת יותר בטוח/ה?"
    ],
      [
      "מה אני הכי חושש/ת שיקרה במפגש?",
      "איזה משפט פנימי עולה כשאני מדמיין/ת דחייה?",
      "מה יכול לעזור לי להרגיש קצת יותר בטוח/ה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד מדחייה הוא צורך בקרבה וביטחון."
    ],
      [
      "פחד מדחייה הוא צורך בקרבה וביטחון."
    ]
    ),
    action: localizedGenderNode(
      "אני שם/ה לב לפחד בלי להילחם בו.",
      "אני שם/ה לב לפחד בלי להילחם בו."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "קול הביקורת",
    opening: localizedGenderNode(
      [
      "היום אני מבחין/ה בקול שמבקר אותי לפני מפגש.",
      "אני מקשיב/ה בלי להאמין לו.",
      "נשימה אחת."
    ],
      [
      "היום אני מבחין/ה בקול שמבקר אותי לפני מפגש.",
      "אני מקשיב/ה בלי להאמין לו.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול הביקורתי אומר לי?",
      "איזו מילה הוא משתמש עליי?",
      "איזה קול עדין יכול לענות לו?"
    ],
      [
      "מה הקול הביקורתי אומר לי?",
      "איזו מילה הוא משתמש עליי?",
      "איזה קול עדין יכול לענות לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול ביקורתי הוא קול מפוחד."
    ],
      [
      "קול ביקורתי הוא קול מפוחד."
    ]
    ),
    action: localizedGenderNode(
      "משפט עדין אחד לעצמי.",
      "משפט עדין אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "גבול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מגדיר/ה גבול פנימי במפגש.",
      "כדי לשמור עליי.",
      "נשימה אחת."
    ],
      [
      "היום אני מגדיר/ה גבול פנימי במפגש.",
      "כדי לשמור עליי.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה לא מתאים לי במרחבים חברתיים?",
      "איך הגוף מסמן שזה יותר מדי?",
      "איזה גבול פנימי אני יכול/ה לשים בלי מילים?"
    ],
      [
      "מה לא מתאים לי במרחבים חברתיים?",
      "איך הגוף מסמן שזה יותר מדי?",
      "איזה גבול פנימי אני יכול/ה לשים בלי מילים?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול פנימי יוצר מרחב נשימה."
    ],
      [
      "גבול פנימי יוצר מרחב נשימה."
    ]
    ),
    action: localizedGenderNode(
      "אני מזכיר/ה לעצמי את הגבול לפני יציאה.",
      "אני מזכיר/ה לעצמי את הגבול לפני יציאה."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "מה אני בוחר/ה",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת את הצורך שמתחת לפחד.",
      "לא כיוון, רק צורך.",
      "נשימה אחת."
    ],
      [
      "היום אני מחפש/ת את הצורך שמתחת לפחד.",
      "לא כיוון, רק צורך.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה במפגש כדי להרגיש בטוח/ה יותר?",
      "מה עוזר לי להרגיש נראות בלי מאמץ?",
      "איזה דבר קטן אני יכול/ה לתת לעצמי?"
    ],
      [
      "מה אני בוחר/ת/ה במפגש כדי להרגיש בטוח/ה יותר?",
      "מה עוזר לי להרגיש נראות בלי מאמץ?",
      "איזה דבר קטן אני יכול/ה לתת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני רואה צורך, משהו נרגע."
    ],
      [
      "כשאני רואה צורך, משהו נרגע."
    ]
    ),
    action: localizedGenderNode(
      "אני נותן/ת לעצמי דבר קטן אחד לפני מפגש.",
      "אני נותן/ת לעצמי דבר קטן אחד לפני מפגש."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "בקשה מעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה מעצמי.",
      "בלי לחץ.",
      "נשימה אחת."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה מעצמי.",
      "בלי לחץ.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו בקשה קטנה אני יכול/ה לבקש מעצמי היום?",
      "איך זה נשמע אם אני אומר/ת את זה ברכות?",
      "מה יעזור לי לזכור את זה בזמן אמת?"
    ],
      [
      "איזו בקשה קטנה אני יכול/ה לבקש מעצמי היום?",
      "איך זה נשמע אם אני אומר/ת את זה ברכות?",
      "מה יעזור לי לזכור את זה בזמן אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה רכה יותר מפקודה."
    ],
      [
      "בקשה רכה יותר מפקודה."
    ]
    ),
    action: localizedGenderNode(
      "אני חוזר/ת על הבקשה פעם אחת.",
      "אני חוזר/ת על הבקשה פעם אחת."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "נוכחות לפני מפגש",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת נוכחות רגע לפני כניסה.",
      "זה מספיק להיום.",
      "נשימה אחת."
    ],
      [
      "היום אני מתרגל/ת נוכחות רגע לפני כניסה.",
      "זה מספיק להיום.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי לזכור שאני לא לבד בפנים?",
      "איזה עוגן קטן אני יכול/ה לקחת איתי?",
      "מה אני רוצה לזכור בתוך המפגש?"
    ],
      [
      "מה עוזר לי לזכור שאני לא לבד בפנים?",
      "איזה עוגן קטן אני יכול/ה לקחת איתי?",
      "מה אני רוצה לזכור בתוך המפגש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "נוכחות היא מגן רך."
    ],
      [
      "נוכחות היא מגן רך."
    ]
    ),
    action: localizedGenderNode(
      "עוגן אחד איתי (מילה / נשימה / מגע).",
      "עוגן אחד איתי (מילה / נשימה / מגע)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן במרחב",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן בתוך מרחב חברתי.",
      "לא מהפכה.",
      "נשימה אחת."
    ],
      [
      "היום אני בוחר/ת צעד קטן בתוך מרחב חברתי.",
      "לא מהפכה.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מהו צעד קטן שמתאים לי?",
      "איך אדע שזה מספיק גם אם זה קטן?",
      "מה אני מבקש/ת מעצמי אחרי זה?"
    ],
      [
      "מהו צעד קטן שמתאים לי?",
      "איך אדע שזה מספיק גם אם זה קטן?",
      "מה אני מבקש/ת מעצמי אחרי זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעדים קטנים בונים אמון."
    ],
      [
      "צעדים קטנים בונים אמון."
    ]
    ),
    action: localizedGenderNode(
      "צעד קטן אחד, וזה מספיק.",
      "צעד קטן אחד, וזה מספיק."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט חזרה לרגעים קשים.",
      "אני נשאר/ת איתי.",
      "נשימה אחת."
    ],
      [
      "היום אני מסיים/ת עם משפט חזרה לרגעים קשים.",
      "אני נשאר/ת איתי.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הפחד הזה?",
      "מה הכי עוזר לי כשהוא עולה?",
      "משפט החזרה הקצר שלי הוא:"
    ],
      [
      "מה למדתי על הפחד הזה?",
      "מה הכי עוזר לי כשהוא עולה?",
      "משפט החזרה הקצר שלי הוא:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להיות נוכח/ת רגע לפני תגובה."
    ],
      [
      "אני יכול/ה להיות נוכח/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת את משפט החזרה פעם אחת היום.",
      "אני אומר/ת את משפט החזרה פעם אחת היום."
    ),
  },
].map(buildNormalizedDay);

export const fearMeetingPeopleSocialEventsBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_meeting_people_social_events_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_meeting_people_social_events",
  category: "anxiety",
  journeyName: {
    he: "פחד ממפגש עם אנשים / אירועים חברתיים",
    en: "Fear of meeting people / social events",
    es: "Miedo a encontrarme con gente / eventos sociales",
  },
  days,
});

export default fearMeetingPeopleSocialEventsBlueprintHe;
